document.addEventListener('DOMContentLoaded', function() {
  var dtfForm = document.querySelector('.dtf-upload-form');
  var relatedWrapper = document.getElementById('related-products-wrapper');
  if (!dtfForm) {
    if (relatedWrapper) {
        relatedWrapper.style.display = 'block';
    }
  } else {
    var checkAndShow = function() {
      try {
      if (window.getComputedStyle(dtfForm).display !== 'none') {
        if (relatedWrapper) {
            relatedWrapper.style.display = 'block';
        }
        observer.disconnect();
        }
      } catch (e) {
        if (relatedWrapper) {
            relatedWrapper.style.display = 'block';
        }
      }
    };
    
    checkAndShow(); 

    var observer = new MutationObserver(checkAndShow);
    observer.observe(dtfForm, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }
  
  const sliderContainer = document.querySelector('.rlt-slider-container');
  const prevButton = document.querySelector('.rlt-slider-arrow.rlt-prev');
  const nextButton = document.querySelector('.rlt-slider-arrow.rlt-next');
  
  if (sliderContainer && prevButton && nextButton) {
    const slideElement = document.querySelector('.rlt-product-slide');
    if (slideElement) {
      const slideWidth = slideElement.offsetWidth + 20;
      
      prevButton.addEventListener('click', function() {
        sliderContainer.scrollBy({
          left: -slideWidth * 2,
          behavior: 'smooth'
        });
      });
      
      nextButton.addEventListener('click', function() {
        sliderContainer.scrollBy({
          left: slideWidth * 2,
          behavior: 'smooth'
        });
      });
    }
  }
  
  const quickViewButtons = document.querySelectorAll('.rlt-quick-add-btn:not(.rlt-sold-out)');
  const modal = document.getElementById('rlt-quick-view-modal');
  const modalBody = document.getElementById('rlt-quick-view-body');
  const closeModalButton = document.getElementById('rlt-quick-view-close');
  
  const productImageLinks = document.querySelectorAll('.rlt-product-image-link');
  if (productImageLinks && productImageLinks.length > 0) {
    productImageLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        const productCard = this.closest('.rlt-product-card');
        if (!productCard) return;
        
        const quickAddBtn = productCard.querySelector('.rlt-quick-add-btn:not(.rlt-sold-out)');
        if (!quickAddBtn) return;
        
        const productHandle = quickAddBtn.getAttribute('data-product-handle');
        if (!productHandle) return;
        
        modalBody.innerHTML = `
          <div style="display:flex; justify-content:center; align-items:center; padding:40px; height:200px;">
            <svg width="60" height="60" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#5433eb">
              <g fill="none" fill-rule="evenodd">
                <g transform="translate(1 1)" stroke-width="2">
                  <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                  <path d="M36 18c0-9.94-8.06-18-18-18">
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="0 18 18"
                      to="360 18 18"
                      dur="1s"
                      repeatCount="indefinite"/>
                  </path>
                </g>
              </g>
            </svg>
          </div>
        `;
        modal.style.display = 'flex';
        
        const themeHeader = document.querySelector('theme-header');
        if (themeHeader) {
          themeHeader.style.display = 'none';
        }
        
        const subheader = document.querySelector('aside.subheader');
        if (subheader) {
          subheader.style.display = 'none';
        }
        
        const announcementBar = document.querySelector('.announcement-bar');
        if (announcementBar) {
          announcementBar.style.display = 'none';
        }
        
        document.body.style.overflow = 'hidden';
        
        fetch(`/products/${productHandle}?section_id=template--18517082341543__main-product`)
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
          })
          .then(html => {
            updateModalContent(html, modalBody, modal, productHandle);
          })
          .catch(error => {
            modalBody.innerHTML = '<p style="text-align:center; padding:20px; color:red;">Error loading product details. Please try again.</p>';
          });
      });
    });
  }

  if (modal && modalBody && closeModalButton) {
    quickViewButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const productHandle = this.getAttribute('data-product-handle');
        
        if (!productHandle) {
          return;
        }

        const originalButtonText = this.textContent;
        this.textContent = 'Loading...';
        this.disabled = true;
        
        modalBody.innerHTML = `
          <div style="display:flex; justify-content:center; align-items:center; padding:40px; height:200px;">
            <svg width="60" height="60" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#5433eb">
              <g fill="none" fill-rule="evenodd">
                <g transform="translate(1 1)" stroke-width="2">
                  <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                  <path d="M36 18c0-9.94-8.06-18-18-18">
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="0 18 18"
                      to="360 18 18"
                      dur="1s"
                      repeatCount="indefinite"/>
                  </path>
                </g>
              </g>
            </svg>
          </div>
        `;
        modal.style.display = 'flex';

        const themeHeader = document.querySelector('theme-header');
        if (themeHeader) {
          themeHeader.style.display = 'none';
        }
        
        document.body.style.overflow = 'hidden';

        fetch(`/products/${productHandle}?section_id=template--18517082341543__main-product`)
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
          })
          .then(html => {
            updateModalContent(html, modalBody, modal, productHandle);
          })
          .catch(error => {
            modalBody.innerHTML = '<p style="text-align:center; padding:20px; color:red;">Error loading product details. Please try again.</p>';
          })
          .finally(() => {
            this.textContent = originalButtonText;
            this.disabled = false;
          });
      });
    });

    closeModalButton.addEventListener('click', function() {
      modal.style.display = 'none';
      modalBody.innerHTML = '';
      
      document.querySelectorAll('.popup-product-form .single-add-to-cart-button').forEach(button => {
        button.disabled = false;
        button.style.opacity = '1';
        button.style.pointerEvents = 'auto';
      });
      
      const themeHeader = document.querySelector('theme-header');
      if (themeHeader) {
        themeHeader.style.display = '';
      }
      
      const subheader = document.querySelector('aside.subheader');
      if (subheader) {
        subheader.style.display = '';
      }
      
      const announcementBar = document.querySelector('.announcement-bar');
      if (announcementBar) {
        announcementBar.style.display = '';
      }
      
      document.body.style.overflow = '';
    });

    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        modal.style.display = 'none';
        modalBody.innerHTML = '';
        
        document.querySelectorAll('.popup-product-form .single-add-to-cart-button').forEach(button => {
          button.disabled = false;
          button.style.opacity = '1';
          button.style.pointerEvents = 'auto';
        });
        
        const themeHeader = document.querySelector('theme-header');
        if (themeHeader) {
          themeHeader.style.display = '';
        }
        
        const subheader = document.querySelector('aside.subheader');
        if (subheader) {
          subheader.style.display = '';
        }
        
        const announcementBar = document.querySelector('.announcement-bar');
        if (announcementBar) {
          announcementBar.style.display = '';
        }
        
        document.body.style.overflow = '';
      }
    });
  }

  document.addEventListener('submit', function(e) {
    const form = e.target;
    
    if (form.action.includes('/cart/add') && !form.classList.contains('popup-product-form') && modal.style.display === 'flex') {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('rlt-quick-view-modal');
    if (!modal) return;
    
    const originalUpdateCartDrawer = window.updateCartDrawer;
    if (typeof originalUpdateCartDrawer === 'function') {
      window.updateCartDrawer = function() {
        rltCloseQuickViewModal({type: 'updateCartDrawer'});
        return originalUpdateCartDrawer.apply(this, arguments);
      };
    }
  });

  document.addEventListener('cart:item-added', rltCloseQuickViewModal);
  document.addEventListener('cart-drawer:open', rltCloseQuickViewModal);
  document.addEventListener('cart:update', rltCloseQuickViewModal);
});

function handleColorSwatches(container, modalBody, modal) {
  const swatchLinks = container.querySelectorAll('.swatch-link, .color-swatches a');
  if (swatchLinks && swatchLinks.length > 0) {
    swatchLinks.forEach(link => {
      const originalHref = link.getAttribute('href');
      
      link.addEventListener('click', function(e) {
        e.preventDefault(); 
        
        let productHandle = '';
        if (originalHref) {
          const urlParts = originalHref.split('/');
          productHandle = urlParts[urlParts.length - 1].split('?')[0];
          
          modalBody.innerHTML = `
            <div style="display:flex; justify-content:center; align-items:center; padding:40px; height:200px;">
              <svg width="60" height="60" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#5433eb">
                <g fill="none" fill-rule="evenodd">
                  <g transform="translate(1 1)" stroke-width="2">
                    <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                    <path d="M36 18c0-9.94-8.06-18-18-18">
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 18 18"
                        to="360 18 18"
                        dur="1s"
                        repeatCount="indefinite"/>
                    </path>
                  </g>
                </g>
              </svg>
            </div>
          `;
          modal.style.display = 'flex';

          const themeHeader = document.querySelector('theme-header');
          if (themeHeader) {
            themeHeader.style.display = 'none';
          }
          
          const subheader = document.querySelector('aside.subheader');
          if (subheader) {
            subheader.style.display = 'none';
          }
          
          const announcementBar = document.querySelector('.announcement-bar');
          if (announcementBar) {
            announcementBar.style.display = 'none';
          }
          
          document.body.style.overflow = 'hidden';
          
          fetch(`/products/${productHandle}?section_id=template--18517082341543__main-product`)
            .then(response => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.text();
            })
            .then(html => {
              updateModalContent(html, modalBody, modal, productHandle);
            })
            .catch(error => {
              modalBody.innerHTML = '<p style="text-align:center; padding:20px; color:red;">Error loading product details. Please try again.</p>';
            });
        }
      });
    });
  }
}

function updateModalContent(html, modalBody, modal, productHandle) {
  modalBody.innerHTML = '';
  
  for (const key in modalBody.dataset) {
    delete modalBody.dataset[key];
  }
  
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  
  let variantsData = [];
  const variantScriptTag = doc.querySelector('variant-selects script[type="application/json"]');
  if (variantScriptTag) {
    try {
      variantsData = JSON.parse(variantScriptTag.textContent);
      modalBody.dataset.variants = JSON.stringify(variantsData);
    } catch (e) {
      modalBody.dataset.variants = '[]'; 
    }
  } else {
    modalBody.dataset.variants = '[]'; 
  }
  
  const productContainer = document.createElement('div');
  productContainer.className = 'quick-view-product-container';
  
  const isMobile = window.innerWidth <= 767;
  updateProductContainerLayout(productContainer, isMobile);
  
  const handleResize = () => {
    const isMobileNow = window.innerWidth <= 767;
    updateProductContainerLayout(productContainer, isMobileNow);
  };
  
  window.addEventListener('resize', handleResize);
  modalBody.addEventListener('DOMNodeRemoved', function(e) {
    if (e.target === modalBody || modalBody.contains(e.target)) {
      window.removeEventListener('resize', handleResize);
    }
  });
  
  const productInfo = document.createElement('div');
  productInfo.className = 'quick-view-product-info';
  
  const productGridContainer = doc.querySelector('.product-grid-container');
  
  if (productGridContainer) {
    const productGalleryContainer = productGridContainer.querySelector('.product-gallery-sticky');
    const productInformationContainer = productGridContainer.querySelector('.product-information');
    
    if (productGalleryContainer) {
      const galleryClone = productGalleryContainer.cloneNode(true);
      
      const thumbnailContainer = galleryClone.querySelector('.product-thumbnail-container');
      if (thumbnailContainer) {
        thumbnailContainer.style.display = 'none';
      }
      
      const scrollShadowElement = galleryClone.querySelector('scroll-shadow');
      if (scrollShadowElement) {
        scrollShadowElement.style.display = 'none';
      }
      
      galleryClone.style.maxWidth = '100%';
      galleryClone.style.width = '100%';
      galleryClone.style.height = '100%';
      galleryClone.style.paddingLeft = '0';
      
      if (isMobile) {
        galleryClone.style.marginBottom = '20px';
      }
      
      const galleryWrapper = document.createElement('div');
      galleryWrapper.className = 'product-gallery-wrapper';
      galleryWrapper.style.maxWidth = '100%';
      galleryWrapper.style.width = '100%';
      galleryWrapper.appendChild(galleryClone);
      
      productContainer.appendChild(galleryWrapper);
    }
    
    if (productInformationContainer) {
      const infoClone = productInformationContainer.cloneNode(true);
      
      infoClone.style.maxWidth = '100%';
      infoClone.style.width = '100%';
      infoClone.style.display = 'block';
      
      const priceContainer = infoClone.querySelector('.product-price-container');
      if (priceContainer) {
        const startingAtLabel = document.createElement('span');
        startingAtLabel.className = 'rlt-price-label';
        startingAtLabel.textContent = 'starting at';
        startingAtLabel.style.display = 'block';
        startingAtLabel.style.fontSize = '12px';
        startingAtLabel.style.color = '#6c757d';
        startingAtLabel.style.marginBottom = '-3px';
        
        priceContainer.insertBefore(startingAtLabel, priceContainer.firstChild);
      }
      
      const fastDeliveryElement = infoClone.querySelector('#fast-delivery-wrapper');
      if (fastDeliveryElement) {
        fastDeliveryElement.remove();
      }
      
      const infoWrapper = document.createElement('div');
      infoWrapper.className = 'product-info-wrapper';
      infoWrapper.style.maxWidth = '100%';
      infoWrapper.style.width = '100%';
      infoWrapper.appendChild(infoClone);
      
      const viewFullDetailsLink = document.createElement('a');
      if (productHandle) {
        viewFullDetailsLink.href = window.location.origin + '/products/' + productHandle;
        viewFullDetailsLink.target = '_blank';
        viewFullDetailsLink.className = 'view-full-details-link';
        viewFullDetailsLink.textContent = 'View Full Details';
        viewFullDetailsLink.style.display = 'block';
        viewFullDetailsLink.style.marginTop = '20px';
        viewFullDetailsLink.style.marginBottom = '10px';
        viewFullDetailsLink.style.textAlign = 'center';
        viewFullDetailsLink.style.color = '#5433eb';
        viewFullDetailsLink.style.textDecoration = 'none';
        viewFullDetailsLink.style.fontWeight = '500';
        viewFullDetailsLink.style.padding = '10px';
        viewFullDetailsLink.style.borderRadius = '4px';
        viewFullDetailsLink.style.fontSize = '15px';
        viewFullDetailsLink.style.transition = 'all 0.2s ease';
        infoWrapper.appendChild(viewFullDetailsLink);
      }
      
      productContainer.appendChild(infoWrapper);
    } else {
      const productTitle = doc.querySelector('.product-title');
      if (productTitle) {
        productInfo.innerHTML = `<div class="product-title-container"><h1 class="product-title">${productTitle.textContent}</h1></div>`;
        productContainer.appendChild(productInfo);
      }
    }
  } else {
    const productGallery = document.createElement('div');
    productGallery.className = 'quick-view-product-gallery';
    
    const galleryElement = doc.querySelector('.product-gallery-container');
    if (galleryElement) {
      productGallery.innerHTML = galleryElement.innerHTML;
      productGallery.style.paddingLeft = '0';
      
      if (isMobile) {
        productGallery.style.marginBottom = '20px';
      }
    } else {
      const productImage = doc.querySelector('.product-featured-image, .product-image-container img');
      if (productImage) {
        productGallery.innerHTML = `<div class="product-image-container" style="width:100%"><img src="${productImage.src}" alt="${productImage.alt || 'Product Image'}" style="width:100%;height:auto;"></div>`;
      }
    }
    
    const productInfoElement = doc.querySelector('.product-information');
    if (productInfoElement) {
      const infoHTML = productInfoElement.innerHTML;
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = infoHTML;
      
      const priceContainer = tempDiv.querySelector('.product-price-container');
      if (priceContainer) {
        const startingAtLabel = document.createElement('span');
        startingAtLabel.className = 'rlt-price-label';
        startingAtLabel.textContent = 'starting at';
        startingAtLabel.style.display = 'block';
        startingAtLabel.style.fontSize = '12px';
        startingAtLabel.style.color = '#6c757d';
        startingAtLabel.style.marginBottom = '-3px';
        
        priceContainer.insertBefore(startingAtLabel, priceContainer.firstChild);
      }
      
      const fastDeliveryElement = tempDiv.querySelector('#fast-delivery-wrapper');
      if (fastDeliveryElement) {
        fastDeliveryElement.remove();
      }
      
      productInfo.innerHTML = tempDiv.innerHTML;
    } else {
      const productTitle = doc.querySelector('.product-title');
      if (productTitle) {
        productInfo.innerHTML = `<div class="product-title-container"><h1 class="product-title">${productTitle.textContent}</h1></div>`;
      }
    }
    
    productContainer.appendChild(productGallery);
    productContainer.appendChild(productInfo);
  }
  
  const quantityInputs = doc.querySelector('#quantity-inputs');
  if (quantityInputs) {
    const quantityInputsClone = quantityInputs.cloneNode(true);
    
    const inputs = quantityInputsClone.querySelectorAll('.size-quantity-input');
    if (inputs) {
      inputs.forEach(input => {
        input.value = 0;
      });
    }
    
    const infoWrapper = productContainer.querySelector('.product-info-wrapper .product-information');
    if (infoWrapper) {
      infoWrapper.appendChild(quantityInputsClone);
    } else {
      const productInfoDirect = productContainer.querySelector('.quick-view-product-info');
      if (productInfoDirect) {
        productInfoDirect.appendChild(quantityInputsClone);
      }
    }
    
    const quantityScript = document.createElement('script');
    quantityScript.src = "https://cdn.shopify.com/extensions/94132a8e-6a2d-4846-9856-5d799e6e4d5c/dtf-file-uploader-1346/assets/quantity_inputs_widget.js";
    quantityScript.defer = true;
    document.body.appendChild(quantityScript);
  }
  
  modalBody.appendChild(productContainer);
  
  if (isMobile) {
    modalBody.style.padding = '10px';
    modalBody.style.overflowX = 'hidden';
  }
  
  const popupForms = productContainer.querySelectorAll('form[action="/cart/add"]');
  popupForms.forEach((form, index) => {
    form.classList.add('popup-product-form');
    form.setAttribute('data-popup-form', 'true');
    form.id = `popup-cart-form-${Date.now()}-${index}`;
    setupCustomAddToCart(form, modal, modalBody);
  });
  
  handleColorSwatches(productContainer, modalBody, modal);
  
  initializeProductSlider();
  
  setTimeout(() => {
    addPriceLabelsToSizeInputs(modalBody);
  }, 500);
  
  setTimeout(() => {
    initializeQuantityInputListeners(modalBody);
  }, 500);
  
  doc.querySelectorAll('script').forEach(scriptEl => {
    if (scriptEl.src && !document.querySelector(`script[src="${scriptEl.src}"]`)) {
      const script = document.createElement('script');
      script.src = scriptEl.src;
      script.defer = true;
      document.body.appendChild(script);
    }
  });
}
function updateProductContainerLayout(container, isMobile) {
  if (isMobile) {
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.gap = '10px';
  } else {
    container.style.display = 'grid';
    container.style.gridTemplateColumns = '35% 1fr';
    container.style.gap = '12px';
  }
}

function initializeProductSlider() {
  const modalBody = document.getElementById('rlt-quick-view-body');
  if (!modalBody) return;

  const productSliders = modalBody.querySelectorAll('product-slider');
  
  if (productSliders.length > 0) {
    if (typeof customElements.get('product-slider') === 'undefined') {
      const sliderScript = Array.from(document.querySelectorAll('script')).find(script => 
        script.src && script.src.includes('product-slider.js')
      );
      
      if (sliderScript) {
        const newScript = document.createElement('script');
        newScript.src = sliderScript.src;
        newScript.defer = true;
        document.body.appendChild(newScript);
      }
    }
    
    setTimeout(() => {
      productSliders.forEach(slider => {
        slider.dispatchEvent(new CustomEvent('reinitialize'));
        
        const prevButton = slider.querySelector('.slideshow-arrow--prev');
        const nextButton = slider.querySelector('.slideshow-arrow--next');
        
        if (prevButton && nextButton) {
          prevButton.addEventListener('click', function() {
            slider.querySelector('.product-images').scrollBy({
              left: -300,
              behavior: 'smooth'
            });
          });
          
          nextButton.addEventListener('click', function() {
            slider.querySelector('.product-images').scrollBy({
              left: 300,
              behavior: 'smooth'
            });
          });
        }
      });
    }, 500);
  }
}

function addPriceLabelsToSizeInputs(container) {
  try {
    const variantsJson = container.dataset.variants;
    if (!variantsJson) {
      return;
    }
    
    const variantsData = JSON.parse(variantsJson);
    const quantityInputContainers = container.querySelectorAll('.size-quantity-item');
    
    if (!quantityInputContainers || quantityInputContainers.length === 0) {
      return;
    }
    
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
    
    quantityInputContainers.forEach(container => {
      const input = container.querySelector('.size-quantity-input');
      if (!input) return;
      
      const sizeValue = input.getAttribute('data-size-value');
      if (!sizeValue) return;
      
      const matchingVariant = variantsData.find(variant => 
        variant.option1 === sizeValue
      );
      
      if (!matchingVariant) return;
      
      if (container.querySelector('.size-price-label')) return;
      
      const price = matchingVariant.price / 100;
      const priceLabel = formatter.format(price);
      
      const priceLabelElement = document.createElement('div');
      priceLabelElement.className = 'size-price-label';
      priceLabelElement.textContent = priceLabel;
      priceLabelElement.style.fontSize = '15px';
      priceLabelElement.style.color = '#5433eb';
      priceLabelElement.style.marginTop = '5px';
      priceLabelElement.style.textAlign = 'center';
      priceLabelElement.style.fontWeight = '600';
      
      container.appendChild(priceLabelElement);
    });
  } catch (e) {
  }
}

function initializeQuantityInputListeners(container) {
  const quantityInputs = container.querySelectorAll('.size-quantity-input');
  if (!quantityInputs || quantityInputs.length === 0) {
    return;
  }
  
  quantityInputs.forEach(input => {
    input.addEventListener('input', function() {
      updateButtonState(container);
    });
  });
  
  updateButtonState(container);
}

function updateButtonState(container) {
  const quantityInputs = container.querySelectorAll('.size-quantity-input');
  let totalQuantity = 0;
  
  quantityInputs.forEach(input => {
    totalQuantity += parseInt(input.value) || 0;
  });
  
  const submitButtons = container.querySelectorAll('.popup-product-form button[type="submit"]');
  
  submitButtons.forEach(button => {
    button.disabled = totalQuantity === 0;
    button.style.opacity = totalQuantity === 0 ? '0.5' : '1';
  });
}

function rltCloseQuickViewModal(e) {
  const modal = document.getElementById('rlt-quick-view-modal');
  if (!modal) return;
  
  if (modal.style.display === 'flex' || modal.style.display === 'block') {
    modal.style.display = 'none';
    
    document.querySelectorAll('.popup-product-form .single-add-to-cart-button').forEach(button => {
      button.disabled = false;
      button.style.opacity = '1';
      button.style.pointerEvents = 'auto';
    });
    
    const themeHeader = document.querySelector('theme-header');
    if (themeHeader) themeHeader.style.display = '';
    
    const subheader = document.querySelector('aside.subheader');
    if (subheader) {
      subheader.style.display = '';
    }
    
    const announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
      announcementBar.style.display = '';
    }
    
    document.body.style.overflow = '';
    
    const modalBody = document.getElementById('rlt-quick-view-body');
    if (modalBody) {
      if (modalBody.dataset) {
        for (const key in modalBody.dataset) {
          delete modalBody.dataset[key];
        }
      }
      modalBody.innerHTML = '';
      modalBody.setAttribute('data-cleared', 'true');
    }

    if (window.location.pathname === '/cart' || window.location.pathname.endsWith('/cart')) {
      window.location.reload();
    }
  }
}

function setupCustomAddToCart(form, modal, modalBody) {
  if (!form || !form.classList.contains('popup-product-form')) return;
  
  const newForm = form.cloneNode(true);
  form.parentNode.replaceChild(newForm, form);
  form = newForm;
  form.setAttribute('data-product-loaded', 'false');
  form.addEventListener('submit', function(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const qtyContainer = modalBody.querySelector('#quantity-inputs');
    if (!qtyContainer) {
      return addToCartWithDefaultVariant(form, modal);
    }
    
    const quantityInputs = qtyContainer.querySelectorAll('.size-quantity-input');
    let totalQuantity = 0;
    
    quantityInputs.forEach(input => {
      const qty = parseInt(input.value) || 0;
      totalQuantity += qty;
    });
    
    if (totalQuantity === 0) {
      alert('Please select at least one size and quantity');
      return false;
    }
    
    let variantsData = [];
    try {
      if (modalBody.dataset.variants) {
        variantsData = JSON.parse(modalBody.dataset.variants);
      }
    } catch (e) {
    }
    
    const defaultProductId = form.querySelector('input[name="id"]')?.value;
    if (!defaultProductId) {
      return false;
    }
    
    const submitBtn = form.querySelector('button[type="submit"]');
    
    if (submitBtn) {
      submitBtn.classList.add('loading');
      submitBtn.disabled = true;
    }
    
    const cartItems = [];
    
    quantityInputs.forEach(input => {
      const qty = parseInt(input.value) || 0;
      if (qty > 0) {
        const sizeValue = input.dataset.sizeValue;
        let variantId = defaultProductId;
        
        if (variantsData.length > 0) {
          const matchingVariant = variantsData.find(variant => 
            variant.option1 === sizeValue || 
            variant.title === sizeValue ||
            variant.options.includes(sizeValue)
          );
          
          if (matchingVariant && matchingVariant.id) {
            variantId = matchingVariant.id.toString();
          }
        }
        
        for (let i = 0; i < qty; i++) {
          cartItems.push({
            id: variantId,
            quantity: 1,
            properties: {
              'Size': sizeValue
            }
          });
        }
      }
    });
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({
        items: cartItems
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    })
    .then(data => {
      updateCartAndCloseModal(modal);
    })
    .catch(error => {
      alert('An error occurred while adding to cart. Please try again.');
    })
    .finally(() => {
      setTimeout(() => {
        if (submitBtn) {
          submitBtn.classList.remove('loading');
          submitBtn.disabled = false;
        }
      }, 1000);
    });
    
    return false;
  });
}

function addToCartWithDefaultVariant(form, modal) {
  const idInput = form.querySelector('input[name="id"]');
  if (!idInput) return false;
  
  const productId = idInput.value;
  const submitBtn = form.querySelector('button[type="submit"]');
  
  if (submitBtn) {
    submitBtn.classList.add('loading');
    submitBtn.disabled = true;
  }
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
    body: JSON.stringify({
      items: [{
        id: productId,
        quantity: 1
      }]
    })
  })
  .then(response => {
    if (!response.ok) throw new Error('Add to cart failed');
    return response.json();
  })
  .then(data => {
    updateCartAndCloseModal(modal);
  })
  .catch(error => {
    alert('An error occurred while adding to cart. Please try again.');
  })
  .finally(() => {
    setTimeout(() => {
      if (submitBtn) {
        submitBtn.classList.remove('loading');
        submitBtn.disabled = false;
      }
    }, 1000);
  });
  
  return false;
}

function updateCartAndCloseModal(modal) {
  const sections = ['cart-drawer', 'cart-bubble'];
  
  fetch(`${window.location.pathname}?sections=${sections.join(',')}`)
    .then(response => response.json())
    .then(sectionsData => {
      if (sectionsData['cart-drawer'] && document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').innerHTML = 
          new DOMParser().parseFromString(sectionsData['cart-drawer'], 'text/html')
            .querySelector('.cart-drawer').innerHTML;
      }
      
      if (sectionsData['cart-bubble'] && document.getElementById('cart-drawer-toggle')) {
        const bubbleContent = new DOMParser()
          .parseFromString(sectionsData['cart-bubble'], 'text/html')
          .querySelector('.thb-item-count');
        
        if (bubbleContent && document.querySelector('.thb-item-count')) {
          document.querySelector('.thb-item-count').innerHTML = bubbleContent.innerHTML;
        }
      }
      
      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        
        if (typeof document.getElementById('Cart-Drawer').removeProductEvent === 'function') {
          document.getElementById('Cart-Drawer').removeProductEvent();
        }
      }
      
      modal.style.display = 'none';
      document.body.style.overflow = '';
      const themeHeader = document.querySelector('theme-header');
      if (themeHeader) themeHeader.style.display = '';
      
      const subheader = document.querySelector('aside.subheader');
      if (subheader) {
        subheader.style.display = '';
      }
      
      const announcementBar = document.querySelector('.announcement-bar');
      if (announcementBar) {
        announcementBar.style.display = '';
      }
      
      const modalBody = document.getElementById('rlt-quick-view-body');
      if (modalBody) {
        if (modalBody.dataset) {
          for (const key in modalBody.dataset) {
            delete modalBody.dataset[key];
          }
        }
        
        modalBody.innerHTML = '';
        
        modalBody.setAttribute('data-cleared', 'true');
      }

      if (window.location.pathname === '/cart' || window.location.pathname.endsWith('/cart')) {
        window.location.reload();
      }
    });
} 